import { Card, CardContent } from "../../ui/card";
import { formatNumber } from "../formatters";

const buildCoreItems = (stats) => [
  { key: "minted", label: "Minted", value: stats.grandTotalMinted, tone: "minted" },
  {
    key: "transferred",
    label: "Transferred",
    value: stats.grandTotalTransferred,
    tone: "transferred",
  },
  {
    key: "deposits",
    label: "Deposits",
    value: stats.globalDepositCount,
    tone: "deposits",
  },
  {
    key: "games",
    label: "Games",
    value: (stats.gamesPlayedCount || 0) * 2,
    tone: "games",
  },
];

const buildMarketItems = (stats) => [
  {
    key: "rswap",
    label: "RSwap Trades",
    value: stats.reddicksDexTradeCount,
    tone: "rswap",
  },
  {
    key: "major-swaps",
    label: "Major DEX Swaps",
    value: stats.swapsTradeCount,
    tone: "swaps",
  },
];

const BreakdownPanel = ({ title, items }) => (
  <div className="leaderboard-total-panel">
    <span className="leaderboard-total-panel-title">{title}</span>
    <div className="leaderboard-total-panel-grid">
      {items.map((item) => (
        <div
          key={item.key}
          className={`leaderboard-total-chip leaderboard-total-chip-${item.tone}`}
        >
          <span>{item.label}</span>
          <strong>{formatNumber(item.value)}</strong>
        </div>
      ))}
    </div>
  </div>
);

const UnifiedTransactionsHero = ({ stats, mode = "dckslap" }) => {
  const coreItems = buildCoreItems(stats);
  const marketItems = buildMarketItems(stats);
  const isReddicksMode = mode === "reddicks";
  const formulaHint = isReddicksMode
    ? "Market side tracks RSwap and major Radix DEX swap counts."
    : "Core side tracks minted, transferred, deposits, and gameplay events.";

  return (
    <Card className="leaderboard-surface-card leaderboard-total-card">
      <CardContent className="pt-6">
        <div className="leaderboard-total-header">
          <span className="leaderboard-total-kicker">Unified Network Impact</span>
          <span className="leaderboard-total-title">Total Radix Transactions</span>
          <span className="leaderboard-total-value">
            {formatNumber(stats.grandTotalVolume)}
          </span>
          <span className="leaderboard-total-note">{formulaHint}</span>
        </div>

        <div className="leaderboard-total-grid">
          <BreakdownPanel
            title={
              isReddicksMode
                ? "Market Contribution"
                : "DCKSLAP Core Contribution"
            }
            items={isReddicksMode ? marketItems : coreItems}
          />
          <BreakdownPanel
            title={
              isReddicksMode
                ? "DCKSLAP Core Contribution"
                : "Market Contribution"
            }
            items={isReddicksMode ? coreItems : marketItems}
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default UnifiedTransactionsHero;
